import React from "react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import { Box, Text } from "@chakra-ui/react"
import ConfigBlock from "pages/EventShow/Forms/StyleAndConfiguration/ConfigBlock"
import TextField from "components/ReactHookForm/TextField"
import { DioboxEvent } from "sharedTypes"
import ModalContentWrapper from "./ModalContentWrapper"

type Props = {
  onHide: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
  onChangeEventWorkingCopy: (values: Partial<DioboxEvent>) => void
  onResetEventWorkingCopy: () => void
}

const PageHeaderModal = ({
  onHide,
  event: {
    portalShowPageHeader,
    portalPageHeader,
    whiteLabel,
  },
  updateEvent,
  onChangeEventWorkingCopy,
  onResetEventWorkingCopy,
}: Props) => {
  const values = {
    portalShowPageHeader,
    portalPageHeader,
    notWhiteLabel: !whiteLabel,
  }

  const updateEventWithNoWhiteLabel = (data) => {
    const { notWhiteLabel, ...eventToUpdate } = data
    eventToUpdate.whiteLabel = !notWhiteLabel

    return updateEvent(eventToUpdate)
  }

  const handleSubmit = async (data) => {
    await updateEventWithNoWhiteLabel(data)
    onHide()
  }

  const handleCancel = () => {
    onResetEventWorkingCopy()
    onHide()
  }

  return (
    <ModalForm
      size="xl"
      noPadding
      initialValues={values}
      title="Page Header"
      onSubmit={handleSubmit}
      onClose={handleCancel}
      onChange={onChangeEventWorkingCopy}
      disableSubmitWhenNotDirty
    >
      {({ control, watch }) => {
        const pageHeaderEnabled = watch("portalShowPageHeader")

        return (
          <ModalContentWrapper>
            <ConfigBlock title="Enabled" switchName="portalShowPageHeader" control={control}>
              <Text>
                Set the header that appears across all Guest Portal pages. It
                typically should be your organization&apos;s name.
              </Text>
              <Box mt={4}>
                <TextField disabled={!pageHeaderEnabled} variant="outline" control={control} name="portalPageHeader" />
              </Box>
              <Text color="gray.500" fontSize="sm">
                When enabled, guests will also see a dropdown menu with options to
                edit their profile and manage email preferences.
              </Text>
            </ConfigBlock>
          </ModalContentWrapper>
        )
      }}
    </ModalForm>
  )
}

export default PageHeaderModal
